export enum OrderCriteriaType {
    DEFAULT, PASSEDEXAMS, EXAMSSCORE
}

export enum OrderCriteriaTranslations {
    DEFAULT = 'lang.shared.defaultCriteria',
    PASSEDEXAMS = 'lang.shared.criteriaPassedExams',
    EXAMSSCORE = 'lang.shared.criteriaExamsScore'
}
